import { render, staticRenderFns } from "./jichu.vue?vue&type=template&id=4980c280"
import script from "./jichu.vue?vue&type=script&lang=js"
export * from "./jichu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports